function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 1C18.5523 1 19 1.44772 19 2V8H20C21.5977 8 22.9037 9.24892 22.9949 10.8237L23 11V16C23 17.6569 21.6569 19 20 19H18C17.4477 19 17 18.5523 17 18C17 17.4477 17.4477 17 18 17H20C20.5523 17 21 16.5523 21 16V11C21 10.4477 20.5523 10 20 10H4C3.44772 10 3 10.4477 3 11V16C3 16.5523 3.44772 17 4 17H6C6.55228 17 7 17.4477 7 18C7 18.5523 6.55228 19 6 19H4C2.34315 19 1 17.6569 1 16V11C1 9.34315 2.34315 8 4 8H5V2C5 1.48716 5.38604 1.06449 5.88338 1.00673L6 1H18ZM17 3H7V8H17V3Z",
  fill: "#3EB1C8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 13C18.5523 13 19 13.4477 19 14V22C19 22.5523 18.5523 23 18 23H6C5.44772 23 5 22.5523 5 22V14C5 13.4477 5.44772 13 6 13H18ZM17 15H7V21H17V15Z",
  fill: "#3EB1C8"
});

function SvgPrinting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinting);
export default __webpack_public_path__ + "static/media/printing.20c53d64.svg";
export { ForwardRef as ReactComponent };